"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Mutex
 */
var Mutex = /*#__PURE__*/function () {
  /**
   * Creates a new Mutex.
   *
   * @param {number} maxCount Number of simultaneous locks to allow before other callers must wait.
   */
  function Mutex() {
    var _this = this;

    var maxCount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

    _classCallCheck(this, Mutex);

    this.queue = [];
    this.count = 0; // Number currently running

    this.maxCount = maxCount;

    this.addToQueue = function (release) {
      _this.queue.push(release);
    };
  }
  /**
   * Takes a lock, causing execution to wait if number of callers exceeds maxCount.
   *
   * @returns {void|Promise} Promise resolved or not depending on if caller must wait.
   */


  _createClass(Mutex, [{
    key: "lock",
    value: function lock() {
      // Do we event need to wait?
      if (this.count < this.maxCount) {
        // No
        this.count++;
        return Promise.resolve();
      } // Yes, we have to wait for our turn


      return new Promise(this.addToQueue);
    }
    /**
     * Releases a previously taken lock.
     */

  }, {
    key: "release",
    value: function release() {
      this.count--;

      this._update();
    }
    /**
     * Resolves promises (locks) down to maxCount.
     */

  }, {
    key: "_update",
    value: function _update() {
      while (this.count < this.maxCount && // We still have space
      this.queue.length !== 0 // We have executers in line
      ) {
        var release = this.queue.shift();
        this.count++;
        release();
      }
    }
  }]);

  return Mutex;
}();

exports.default = Mutex;